import { useEffect, useState } from "react";

/**
 * True while `query` matches, tracking changes (rotation, resize). Reads the
 * initial value synchronously so the first paint is already correct — a
 * false-then-true flip would show the wrong layout for a frame. Safe where
 * `matchMedia` is missing (jsdom, very old WebViews): reports false.
 */
export function useMediaQuery(query: string): boolean {
  const get = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState<boolean>(get);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
